import {LeaveDetail, serializeType, TimesheetPeriod, UserType} from "@app/shared";
import {TimesheetError, StatusType} from "@app/finance/time/timesheet";
import {Type} from "class-transformer";
import {EmployeeLeaveHistorySummary} from "@app/finance/time/init-leave-balance/init-leave-balance";

export class TimesheetAdminSearchOption {
  year: string;
  period: TimesheetPeriod;
  status: string;
  userType: string;
  showTerminatedUsers: boolean;
  terminationDate: Date;
}

export class LeaveProcessingInfo {
  employeeFullName: string;
  timesheetHeaderId: number;
  timesheetPeriodLabel: string;
  deltaLeaveDetails: LeaveDetail[];
  actualLeaveDetails: LeaveDetail[];
  unearnedSickHours: number;
  updateUnEarnedHours: boolean;
  accrueSickBasedOnHoursWorked: boolean;
  deltaExists: boolean;

  leaveDetailInfos?: LeaveDetailInfo[];
}

export class LeaveDetailInfo {
  leaveType: string;
  expectedHours: number;
  actualHours: number;
  deltaHours: number;
  requireReconcile: boolean;
}

export class TimesheetDashboard {
  totalTimesheets: number;
  totalOpen: number;
  totalMissing: number;
  totalSigned: number;
  totalApproved: number;
  totalRejected: number;
  totalPartialClosed: number;
  totalFinalClosed: number;
  totalProcessed: number;
  totalError: number;
  totalClosingError: number;
  totalProcessingError: number;
}

export class PeriodStatusSummary {
  timesheetId: number;
  status: StatusType;
  timesheetPeriodId: number;
  timesheetPeriod: string;
  timesheetPeriodNumber: number;
  timesheetPeriodAsString: string;
  periodStartOn: string;
  periodEndOn: string;
  revision: number;

  userId: number;
  userEmail: string;
  userFullName: string;
  subtype: UserType;

  managerId: number;
  managerEmail: string;
  managerFullName: string;

  errors: TimesheetError[];
}

export class TimesheetAdminSummary {
  annualLeaveBalancesInitialized: boolean;
  prevYearTimesheetProcessed: boolean;
  allowTsAdminToEditTimesheets: boolean;
  fiscalYear: string;
  @Type(serializeType(TimesheetDashboard)) dashboard: TimesheetDashboard;
  @Type(serializeType(PeriodStatusSummary)) statusSummaries: PeriodStatusSummary[];
}

export enum TimesheetNotificationType {
  User = "user",
  ManagerIndividual = "managerIndvMail",
  ManagerGroup = "managerGroupMail",
}
